import { Component } from "@angular/core";
import { BaseDialogComponent } from "@common/ux/adapt-common-dialog/base-dialog.component/base-dialog.component";
import { PositionConfig } from "devextreme/animation/position";
import { ChatAiUiService, ChatLocationMode } from "../chat-ai-ui.service";

@Component({
    selector: "adapt-chat-ai-sticky-dialog",
    standalone: false,
    templateUrl: "./chat-ai-sticky-dialog.component.html",
    styleUrl: "./chat-ai-sticky-dialog.component.css",
})
export class ChatAiStickyDialogComponent extends BaseDialogComponent<void> {
    public readonly dialogName = "ChatAiStickyDialog";

    public position: PositionConfig = {
        my: "right bottom",
        at: "right bottom",
        of: window,
        offset: { x: 0, y: -70 },
    };

    public constructor(
        public chatUiService: ChatAiUiService,
    ) {
        super();
    }

    public moveToSidebar() {
        this.chatUiService.chatLocationMode = ChatLocationMode.Sidebar;
    }
}
